import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import CallToActionContainer from '@/components/common/callToAction/CallToActionContainer';

import styles from './Card3.module.scss';

export const Card3 = ({ data }) => {
  const router = useRouter();
  const { img, contentTitle, desc, cta } = data;

  const handleClick = (link) => {
    router.push(link);
  };

  return (
    <div
      className={styles.container}
      onClick={() => handleClick(cta.url)}
      style={{ backgroundImage: `url(${img})` }}
      data-test-id="card3-container"
    >
      <div className={styles.infos} data-test-id="card3-infos">
        <div className={styles.title} data-test-id="card3-title">
          {contentTitle.toUpperCase()}
        </div>
        <div className={styles.desc} dangerouslySetInnerHTML={{ __html: desc }} data-test-id="card3-desc" />
        <div className={styles.button} data-test-id="card3-button">
          <CallToActionContainer cta={cta} withLink />
        </div>
      </div>
    </div>
  );
};

Card3.propTypes = {
  data: PropTypes.object.isRequired
};

export default Card3;
